import { shallowEqual, useSelector } from "react-redux";
import { getMarvinUIEnabled } from "../utils/marvin-utils";

const useFeatureEnabled = () => {
  const {
    MTEnabled,
    storageS3PathEnabled,
    fbpEnabled,
    MAPEnabled,
    terraformEnabled,
    calendlyEnabled,
    marvinEnabled,
  } = useSelector(({ auth }) => {
    const { features = {} } = auth;
    const {
      MTEnabled = false,
      StorageS3PathEnable = false,
      FBPEnabled = false,
      MAPEnabled = false,
      TerraformEnabled = false,
      CalendlyEnabled = false,
    } = features;
    const isMarvinEnabled = getMarvinUIEnabled(auth);
    return {
      MTEnabled: MTEnabled,
      storageS3PathEnabled: StorageS3PathEnable,
      fbpEnabled: FBPEnabled,
      MAPEnabled: MAPEnabled,
      terraformEnabled: TerraformEnabled,
      calendlyEnabled: CalendlyEnabled,
      marvinEnabled: isMarvinEnabled,
    };
  }, shallowEqual);

  return {
    MTEnabled,
    storageS3PathEnabled,
    fbpEnabled,
    MAPEnabled,
    terraformEnabled,
    calendlyEnabled,
    marvinEnabled,
  };
};

export default useFeatureEnabled;
